// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-components-portfolio-page-tsx": () => import("./../src/components/Portfolio/Page.tsx" /* webpackChunkName: "component---src-components-portfolio-page-tsx" */),
  "component---src-pages-404-tsx": () => import("./../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

